var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme from 'Theme';
import history from 'helpers/History';
import { t } from 'helpers/i18n';
import { Tree } from 'components';
import { Icon } from 'elements';
import { AddButton } from 'Styles';
var FamiliesTree = /** @class */ (function (_super) {
    __extends(FamiliesTree, _super);
    function FamiliesTree(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectItem = function (family) {
            history.push("/families/".concat(family.id));
        };
        _this.handleCreate = function () {
            history.push("/families/create");
        };
        props.store.families.read();
        return _this;
    }
    FamiliesTree.prototype.render = function () {
        var families = this.props.store.families;
        return (React.createElement(Wrapper, null,
            React.createElement(Tree, { data: families.families, renderItem: FamilyLeaf, subTreeExtractor: function (item) { return item.subfamilies; }, keyExtractor: function (item) { return String(item.id); }, onSelectItem: this.handleSelectItem, loading: !families.loaded }),
            React.createElement(AddButton, { primary: true, onClick: this.handleCreate }, t('add'))));
    };
    FamiliesTree = __decorate([
        inject('store'),
        observer
    ], FamiliesTree);
    return FamiliesTree;
}(Component));
export default FamiliesTree;
var FamilyLeaf = function (item, level) { return (React.createElement(Leaf, { level: level - 1 < 0 ? 0 : level - 1 },
    level ? React.createElement(StyledIcon, { name: "arrow" }) : null,
    item.name)); };
var Wrapper = cxs('div')({
    marginBottom: Theme.size.bar
});
var Leaf = cxs('div')(function (_a) {
    var level = _a.level;
    return ({
        padding: "".concat(Theme.common.size.space / 2, "px ").concat(Theme.size.space[1]),
        marginLeft: "".concat(Theme.common.size.space * 1.8 * level, "px")
    });
});
Leaf.propTypes = {
    level: PropTypes.number
};
var StyledIcon = cxs(Icon)({
    padding: 0,
    transform: 'rotate(135deg)'
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Families/containers/FamiliesTree.tsx
// module id = 1573
// module chunks = 0